import { Input, Button, Icon, Flex } from '@chakra-ui/react'
import { Trash02Icon } from '../../assets/icons'

interface SectionCardProps {
  title: string
  onChange: (value: string) => void
  handleDelete?: (id: string | number) => void
  id: string | number
  isDisabled?: boolean
}

const SectionCard: React.FC<SectionCardProps> = ({ title, onChange, handleDelete, id, isDisabled }) => {
  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      w="100%"
      _hover={{ '.trash-button': { opacity: isDisabled ? 0 : 1, visibility: isDisabled ? 'hidden' : 'visible' } }}
    >
      <Input
        size="s"
        variant="contentQuestion"
        color="solid.900"
        value={title}
        placeholder="Write a title for the section..."
        _placeholder={{ color: 'solid.400' }}
        onChange={(e) => !isDisabled && onChange(e.target.value)}
        bg="transparent"
        flex="1"
        mr="4"
        isReadOnly={isDisabled}
        pointerEvents={isDisabled ? 'none' : 'auto'}
        cursor={isDisabled ? 'default' : 'text'}
        border="none"
        _hover={isDisabled ? { border: 'none' } : undefined}
        _focus={isDisabled ? { border: 'none' } : undefined}
      />
      {!isDisabled && (
        <Button
          className="trash-button"
          variant="contentIcon"
          onClick={() => handleDelete && handleDelete(id)}
          opacity={0}
          visibility="hidden"
          transition="opacity 0.2s, visibility 0.2s"
        >
          <Icon boxSize="16px" color="solid.500">
            <Trash02Icon />
          </Icon>
        </Button>
      )}
    </Flex>
  )
}

export default SectionCard
